export const createUtilityProviderRegistrationForm = (registeredUserName = "") => ({
  // Blank on purpose: the person must choose a type before any fields show.
  entityType: "",
  individualName: String(registeredUserName || "").trim(),
  alsoKnownAs: "",
  businessName: "",
  businessType: "",
  businessCityTown: "",
  businessLocation: "",
  businessArea: "",
  companyName: "",
  serviceOffered: "",
  telephoneNumber: "",
  location: "",
  yourPosition: "",
  ownerNames: "",
})

export const buildUtilityProviderRegistrationPayload = (form) => {
  if (form.entityType === "individual") {
    return {
      entityType: "individual",
      alsoKnownAs: form.alsoKnownAs,
    }
  }

  if (form.entityType === "business") {
    return {
      entityType: "business",
      businessName: form.businessName,
      businessType: form.businessType,
      businessCityTown: form.businessCityTown,
      businessLocation: form.businessLocation,
      businessArea: form.businessArea,
    }
  }

  return {
    entityType: "company",
    name: form.companyName,
    serviceOffered: form.serviceOffered,
    telephoneNumber: form.telephoneNumber,
    location: form.location,
    yourPosition: form.yourPosition,
    ownerNames: form.ownerNames,
  }
}
